(function () {
    angular.module("skillBuilderSaaS")
        .controller("QuickLinksCtrl", ["assignmentLearnerAccessResource", "frameworkService", "$scope", QuickLinksCtrl]);
    function QuickLinksCtrl(assignmentLearnerAccessResource, frameworkService, $scope) {
        var vm = this;
        vm.priorityItemsLimit = 5;
        vm.priorityItemsFilter = "";
        vm.expiredExpiringItemsLimit = 5;
        vm.expiredExpiringItemsFilter = "";
        vm.incompleteItemsLimit = 5;
        vm.incomplteItemsFilter = "";
        vm.incompleteItemsOrderByProperty = 'assignedDate';
        vm.incompleteItemsOrderByReverse = false;
        vm.open = false;
        vm.loading = true;
        vm.hasError = false;
        //$scope.$on("openQuickLinks", function () {
        //	vm.loading = true;
        //	loadQuickLinks();
        //	vm.open = true;
        //});
        $scope.$on("toggleQuickLinks", function () {
            vm.loading = true;
            vm.open = !vm.open;
            frameworkService.data.quickLinksOpen = vm.open;
            if (vm.open) {
                loadQuickLinks();
            }
        });
        $scope.$on("reloadQuickLinks", function () {
            if (vm.open)
                loadQuickLinks();
        });
        vm.showMore = function () {
            vm.priorityItemsLimit += 5;
        };
        vm.incompleteItemsOrderBy = function (property) {
            vm.incompleteItemsOrderByReverse = (vm.incompleteItemsOrderByProperty === property) ? !vm.incompleteItemsOrderByReverse : false;
            vm.incompleteItemsOrderByProperty = property;
        };
        function loadQuickLinks() {
            assignmentLearnerAccessResource.getQuickLinks(function (result) {
                vm.mostRecent = result.mostRecentItems;
                vm.priorityItems = result.priorityItems;
                vm.expiredExpiringItems = result.expiredExpiringItems;
                vm.incomplteItems = result.incompletedItems;
                vm.loading = false;
                vm.hasError = false;
            }, function () {
                vm.hasError = true;
            });
        }
    }
}());
